module.exports = __webpack_public_path__ + "img/eventDetails.f6636520.jpg";